import moment from 'moment';

export const formatDate = (date) =>
  date ? moment.utc(date).format('MM/DD/YYYY') : '';
